import LogoutPage from "./LogoutPage";
import LoginSelector from "./LoginSelector";
import LoginSelectorPP from "./LoginSelectorPP";
import DefaultLoginPage from "./DefaultLoginPage";
import DefaultLoginPagePP from "./DefaultLoginPagePP";
import RoleSelectionPage from './RoleSelectionPage'

export { LogoutPage, LoginSelector, DefaultLoginPage, LoginSelectorPP, DefaultLoginPagePP,RoleSelectionPage };



// WEBPACK FOOTER //
// ./components/login/index.js